import { render, staticRenderFns } from "./visualize.vue?vue&type=template&id=02468934&scoped=true&"
import script from "./visualize.vue?vue&type=script&lang=js&"
export * from "./visualize.vue?vue&type=script&lang=js&"
import style0 from "./visualize.vue?vue&type=style&index=0&id=02468934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02468934",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
